import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { UiOperationService } from './services/ui-operation.service';
import { UiOperationFactory } from './services/ui-opertaion.factory';

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    CommonModule,
  ]
})
export class CustomNavigationModule {
  public static forRoot(): ModuleWithProviders<CustomNavigationModule> {
    return {
      ngModule: CustomNavigationModule,
      providers: [
        UiOperationService,
        UiOperationFactory,
      ],
    };
  }
}
